import React from 'react';

import { clsx } from 'clsx';

import { S3_URL } from 'src/components/pages/loyalty/SharingPage/constants';

import styles from './PhoneFrame.scss';

export type PhoneFrameProps = React.ComponentPropsWithoutRef<'div'>;

const PhoneFrame = (props: PhoneFrameProps) => {
  const { children, className, ...restProps } = props;

  return (
    <div className={clsx(styles.root, className)} {...restProps}>
      <div className={styles.content}>
        <img className={styles.statusBar} src={`${S3_URL}svg/status_bar.svg`} alt="" />
        {children}
      </div>
    </div>
  );
};

export default PhoneFrame;
